export default __webpack_public_path__ + "static/media/icons-font.ba922bdc.ttf";